import { render, staticRenderFns } from "./TransmittersList.vue?vue&type=template&id=17be422b"
import script from "./TransmittersList.vue?vue&type=script&lang=js"
export * from "./TransmittersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports